<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model.number="editedItem.fiscalYear"
            id="bankReconTransItemFYSelect"
            class="bank-recon-trans-item-fy-select"
            label="Fiscal Year"
            :rules="reqdSelectValidation"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <ClarionDateControl
            v-model="editedItem.asOfDate"
            :isIsoDate="true"
            label="As Of Date"
            :rules="reqdSelectValidation"
            :isReadOnly="true"
            :isToggle="false"
          />
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="editedItem.bank"
            id="bankReconTransItemBankSelect"
            class="bank-recon-trans-item-bank-select"
            label="Bank"
            item-text="bankName"
            item-value="_id"
            :rules="reqdSelectValidation"
            :items="banks"
            :readonly="!isNewItem"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.bankBalStmnt"
            id="bankReconTransItemBalancePerBankStatementText"
            class="banks-recon-trans-item-bal-per-bank-statement-text"
            label="Balance Per Bank Statement"
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.adjBankBal"
            id="bankReconTransItemAdjBankBalanceText"
            class="banks-recon-trans-item-adj-bank-balance-text"
            label="Adj Bank Balance"
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.generalLedgerBalance"
            id="bankReconTransItemAdjBankBalanceText"
            class="banks-recon-trans-item-adj-bank-balance-text"
            label="General Ledger Balance"
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="differenceBalance"
            id="bankReconTransItemAdjBankBalanceText"
            class="banks-recon-trans-item-adj-bank-balance-text"
            label="Difference"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="d-flex align-end">
        <v-col cols="6">
          <v-textarea
            v-model="editedItem.comment"
            v-textAreaUppercase=globalSettingItem.conEverythingToCaps
            id="bankReconTransItemCommentTextArea"
            class="bank-recon-trans-item-comment-text-area"
            label="Comment"
            rows="2"
          ></v-textarea>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            v-model="editedItem.isSaiMonthly"
            id="bankReconTransItemSaiMonthly"
            class="bank-recon-trans-item-saiMonthly-checkbox"
            label="Sai Monthly"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <BankReconDetails
            v-model="editedItem.details"
            :baseCrudKey="baseCrudKey"
            @addDeductBalance="addDeductBalance"
            @bankBalance="bankBalance"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import BankReconDetails from './BankReconDetails.vue';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

const bankCrudKey = 'sharedBank';

export default {
  name: 'BankReconEditedItem',
  mixins: [GlobalToCaps],
  components: {
    ClarionDateControl,
    BankReconDetails,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'bankRecon-dialog',
    },
  },
  data: () => ({
  }),
  created() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    banks() {
      const bankObjs = this.items(bankCrudKey) || [];
      const filteredBanks = bankObjs.filter((bank) => bank.isReconAcct === true);
      return [{ _id: null, bankName: '' }, ...filteredBanks];
    },

    differenceBalance() {
      const difference = amountToNumber(this.editedItem.adjBankBal)
      - amountToNumber(this.editedItem.generalLedgerBalance);
      return amountFormat(difference);
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    addDeductBalance(value) {
      this.editedItem.adjBankBal = value;
      return this.editedItem.adjBankBal;
    },
    bankBalance(value) {
      this.editedItem.bankBalStmnt = value;
      return this.editedItem.bankBalStmnt;
    },
  },
};
</script>
